import { createContext, useContext } from 'react';

// Opens the one sign-in window (AuthDialogProvider) from anywhere on the public pages:
// openAuth('login' | 'signup' | 'forgot', { afterSignupPath, expired }). Outside the provider it does nothing.
export const AuthDialogContext = createContext({ openAuth: () => {}, closeAuth: () => {} });

export const useAuthDialog = () => useContext(AuthDialogContext);
